import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import {
  getMedia,
  removeMedia,
  getCategoriesMedia,
  getMediaById,
  uploadMedia,
  updateMediaById,
  setCopyMediaToProject,
  checkCopyMedia,
  getProjectList,
  checkCopyMediaByRegion
} from './api';
import * as MediaActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* getListMediaAsync(action) {
  const result = yield call(getMedia, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: MediaActionType.GET_LIST_MEDIA_SUCCESS, data: result.data })
    ];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error
    });
  }
}

export function* uploadMediaAsync(action) {
  const result = yield call(uploadMedia, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: MediaActionType.ADD_MEDIA_SUCCESS, data: result.data}),
      put({ type: MediaActionType.GET_LIST_MEDIA_ASYNC, data: result.data})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* removeMediaAsync(action) {
  const result = yield call(removeMedia, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data
    });
  }
}

export function* getMediaByIdAsync(action) {
  const result = yield call(getMediaById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: MediaActionType.GET_MEDIA_BY_CATEGORIES_SUCCESS, data: result.data
    });
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data
    });
  }
}

export function* updateMediaByIdAsync(action) {
  const result = yield call(updateMediaById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: MediaActionType.UPDATE_MEDIA_BY_ID_SUCCESS, data: result.data }),
      put({ type: MediaActionType.GET_LIST_MEDIA_ASYNC, data: result.data})
    ];
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data
    });
  }
}

export function* getMediaCategoriesAsync(action) {
  const result = yield call(getCategoriesMedia, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: MediaActionType.GET_MEDIA_BY_CATEGORIES_SUCCESS, data: result.data
    });
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data
    });
  }
}
export function* setCopyMediaToProjectAsync(action) {
  const result = yield call(setCopyMediaToProject, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS, data: 'Copied'
    });

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data
    });
  }
}

export function* checkCopyMediaAsync(action) {
  const result = yield call(checkCopyMedia, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: MediaActionType.CHECK_COPY_MEDIA_SUCCESS, data: {projectId: action.params.projectId, copied: result.data.copied}
    });
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data
    });
  }
}

export function* getProjectListAsync(action) {
  const result = yield call(getProjectList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: MediaActionType.GET_PROJECT_LIST_SUCCESS, data: result.data
    });
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data
    });
  }
}

export function* checkCopyMediaByRegionAsync(action) {
  const result = yield call(checkCopyMediaByRegion, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: MediaActionType.CHECK_COPY_MEDIA_BY_REGION_SUCCESS, data: result.data
    });
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data
    });
  }
}

export default function* WatchMediaLibrary() {
  yield all([
    takeLatest(MediaActionType.GET_LIST_MEDIA_ASYNC, getListMediaAsync),
    takeLatest(MediaActionType.DELETE_MEDIA_ASYNC, removeMediaAsync),
    takeLatest(MediaActionType.ADD_MEDIA_ASYNC,uploadMediaAsync),
    takeLatest(MediaActionType.GET_MEDIA_BY_ID_ASYNC,getMediaByIdAsync),
    takeLatest(MediaActionType.UPDATE_MEDIA_BY_ID_ASYNC,updateMediaByIdAsync),
    takeLatest(MediaActionType.GET_MEDIA_BY_CATEGORIES_ASYNC, getMediaCategoriesAsync),
    takeLatest(MediaActionType.SET_COPY_MEDIA_TO_PROJECT_ASYNC, setCopyMediaToProjectAsync),
    takeLatest(MediaActionType.CHECK_COPY_MEDIA_ASYNC, checkCopyMediaAsync),
    takeLatest(MediaActionType.GET_PROJECT_LIST_ASYNC, getProjectListAsync),
    takeLatest(MediaActionType.CHECK_COPY_MEDIA_BY_REGION_ASYNC,checkCopyMediaByRegionAsync)

  ]);
}



// WEBPACK FOOTER //
// ./src/MediaLibrary/saga.js